module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('disclaimer'), _vm._v(" "), _c('app-header', {
    on: {
      "menu": _vm.toggleMenu
    }
  }), _vm._v(" "), (_vm.menuEnabled) ? _c('dimmer') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.menuEnabled) ? _c('app-menu') : _vm._e()], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78816777"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 274
// module chunks = 0